import 'ress';
import '@babel/polyfill';
import domContentLoaded from 'dom-content-loaded';
// import { throttle } from 'throttle-debounce';
import '../scss/style.scss';
import common from './common';

common();

domContentLoaded(() => {
  // 郵便番号の「-」の挿入
  $('.js-insert-hyphen').blur((e) => {
    // eslint-disable-next-line max-len
    const insertStr = (str, index, insert) => str.slice(0, index) + insert + str.slice(index, str.length);
    const input = e.currentTarget;
    const zip = input.value;
    if (zip.length > 6 && !zip.match('-')) {
      input.value = insertStr(zip, 3, '-');
    }
  });
});

window.addEventListener('load', () => {
  document.body.classList.add('is-standby')
})
